import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';

export const discardSupportSchema = z.object({
  reason: z
    .string()
    .trim()
    .nonempty(VALIDATION_MESSAGES.discardSupport.reason.required)
    .min(5, VALIDATION_MESSAGES.discardSupport.reason.min)
    .max(250, VALIDATION_MESSAGES.discardSupport.reason.max),
});

export type TDiscardSupportFormValues = z.infer<typeof discardSupportSchema>;
